import './styles.scss'
import React, { useState } from 'react'
import { Picker } from 'emoji-mart'
import Reaction from './Reaction'

const MessageReaction = ({ user, operator, actionSummaryList, onSelectEmoji }) => {
  const [picker, setShowPicker] = useState(false)

  const defaultEmoji = {
    emoji: 'default_emoji',
    colons: '',
    id: 'default_emoji',
    userId: user.id,
    userNames: [],
  }

  let reactionEmojis = actionSummaryList.filter((el) => el.type.includes('REACT_')).concat(defaultEmoji)

  /**
   * check if the user has already chosen the same emoji
   * @param emoji
   */
  const selectEmoji = (emoji) => {
    onSelectEmoji(emoji.native)
    setShowPicker(!picker)
  }

  /**
   * check if it is default emoji
   * TODO: Change function => when user clicks the same emoji, to delete it
   *
   * @param user
   * @param emoji
   */
  const onClickEmoji = ({
    target: {
      dataset: { user, emoji },
    },
  }) => {
    if (emoji === defaultEmoji.emoji) {
      setShowPicker(!picker)
      return
    }
    // remove existing emoji from reactions of a user
    /*const emojiToRemove = reactions.find((el) => el.id === emoji && el.userId === user)
        const index = reactions.indexOf(emojiToRemove)
        if (index !== -1) {
            const updatedReactions = [...reactions]
            updatedReactions.splice(index, 1)
            setReactions([...updatedReactions])
        } */
  }

  return (
    <div className='reaction-content'>
      {picker && (
        <div className='emoji-selector'>
          <div className='picker-right'>
            <Picker onClick={selectEmoji} />
          </div>
        </div>
      )}
      {reactionEmojis.map((el, index) => {
        return (
          <Reaction
            key={`${index}${el._id}`}
            emoji={el.emoji === 'default_emoji' ? el.emoji : el.type.replace('REACT_', '')}
            //emojiId={el.id}
            //colons={el.colons}
            count={el.count}
            user={user}
            operator={operator}
            handleEmojiClick={onClickEmoji}
            //userNames={el.userNames}
          />
        )
      })}
    </div>
  )
}

export default MessageReaction
